import { SoftCard } from './SoftCard';

export default SoftCard;
